import React from 'react';

// The floating "Follow audio" button, shown once the reader has scrolled away
// from the verse being read (see useFollowVerse). Pressing it scrolls back to
// that verse and keeps following it.
export default function FollowAudioPill({ visible, onClick, label }) {
  if (!visible) return null;
  return (
    <button type="button" className="follow-audio-pill" onClick={onClick}>
      <span className="follow-audio-icon" aria-hidden="true">♪</span>{label}
    </button>
  );
}
